import { LayerGroup } from "./LayerGroup";

interface LayersProps {}

/**
 * Wrapper component for all Layer controls
 */
const Layers: React.FC<LayersProps> = () => {
  return (
    <div className="LayersParent Layers DisplayFlex FlexColumn SmallGap">
      <LayerGroup type="fields" />
      <LayerGroup type="features" />
    </div>
  );
};

export default Layers;
